var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "listContentManage" },
    [
      _c("basic-container", [
        _c(
          "div",
          { staticClass: "query-form-wrap" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  size: _vm.formSize,
                  "label-width": "88px",
                },
              },
              [
                _vm.tableTabs === "live"
                  ? _c(
                      "el-form-item",
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            size: "small",
                            clearable: "",
                            type: "datetimerange",
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "picker-options": _vm.pickerOptions,
                            "range-separator": "至",
                            "start-placeholder": "直播开始日期",
                            "end-placeholder": "直播结束日期",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.searchForm.liveTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "liveTime", $$v)
                            },
                            expression: "searchForm.liveTime",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  [
                    _c("el-date-picker", {
                      staticClass: "dateSelect",
                      attrs: {
                        type: "daterange",
                        "value-format": "yyyy-MM-dd",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                      },
                      model: {
                        value: _vm.searchForm.date,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "date", $$v)
                        },
                        expression: "searchForm.date",
                      },
                    }),
                  ],
                  1
                ),
                _vm.tableTabs !== "lbMedia"
                  ? _c(
                      "el-form-item",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              filterable: "",
                              clearable: "",
                              placeholder: "关联应用",
                            },
                            model: {
                              value: _vm.searchForm.thirdPartyAppId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "thirdPartyAppId", $$v)
                              },
                              expression: "searchForm.thirdPartyAppId",
                            },
                          },
                          _vm._l(_vm.aplicationTypeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          filterable: "",
                          clearable: "",
                          placeholder: "状态",
                        },
                        model: {
                          value: _vm.searchForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "status", $$v)
                          },
                          expression: "searchForm.status",
                        },
                      },
                      _vm._l(_vm.statusList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.bizKey, value: item.bizValue },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.tableTabs === "films" || _vm.tableTabs === "lbMedia"
                  ? _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "内容标题" },
                          model: {
                            value: _vm.searchForm.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "title", $$v)
                            },
                            expression: "searchForm.title",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.tableTabs === "live"
                  ? _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "队伍信息" },
                          model: {
                            value: _vm.searchForm.teamInformation,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "teamInformation", $$v)
                            },
                            expression: "searchForm.teamInformation",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "LIST_CONTENT_MANAGE_SEARCH",
                            expression: "'LIST_CONTENT_MANAGE_SEARCH'",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.getListContent(1)
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "LIST_CONTENT_MANAGE_ADD",
                            expression: "'LIST_CONTENT_MANAGE_ADD'",
                          },
                        ],
                        attrs: { plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick("", 1)
                          },
                        },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.showImport },
                      },
                      [_vm._v("投屏榜媒资导入")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning" },
                        on: {
                          click: () => {
                            _vm.$refs.importLbMedia &&
                              _vm.$refs.importLbMedia.show()
                          },
                        },
                      },
                      [_vm._v("媒资库内容导入")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.tableTabChange },
                model: {
                  value: _vm.tableTabs,
                  callback: function ($$v) {
                    _vm.tableTabs = $$v
                  },
                  expression: "tableTabs",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "直播赛事", name: "live" } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          border: "",
                          data: _vm.tableData,
                          height: "600px",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "id", label: "ID", width: "180" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "teamA",
                            label: "队伍信息",
                            width: "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v(_vm._s(scope.row.teamA))]),
                                  _vm._v(" VS "),
                                  _c("span", [_vm._v(_vm._s(scope.row.teamB))]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "coverImg",
                            label: "队伍图片",
                            width: "150",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px",
                                        },
                                        attrs: {
                                          src: scope.row.teamAImg,
                                          "preview-src-list": [
                                            scope.row.teamAImg,
                                          ],
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleClickItem.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v(" VS ")]),
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "50px",
                                          height: "50px",
                                        },
                                        attrs: {
                                          src: scope.row.teamBImg,
                                          "preview-src-list": [
                                            scope.row.teamBImg,
                                          ],
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleClickItem.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "thirdPartyAppName",
                            label: "关联应用",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "matchStartTime",
                            label: "直播时间",
                            width: "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.matchStartTime) +
                                        " - " +
                                        _vm._s(scope.row.matchEndTime)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "liveStatus", label: "直播状态" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.liveStatus === 1
                                    ? _c("span", [_vm._v("未开始")])
                                    : scope.row.liveStatus === 2
                                    ? _c("span", [_vm._v("直播中")])
                                    : scope.row.liveStatus === 3
                                    ? _c("span", [_vm._v("已结束")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "status", label: "状态" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status === 0
                                    ? _c("span", [_vm._v("下架")])
                                    : scope.row.status === 1
                                    ? _c("span", [_vm._v("上架")])
                                    : scope.row.status === 2
                                    ? _c("span", [_vm._v("待上架")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "createTime", label: "创建时间" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "effectStartTime", label: "上架时间" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status !== 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.effectStartTime) +
                                            " 至 " +
                                            _vm._s(scope.row.effectEndTime)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "remark", label: "备注" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_LOG",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_LOG'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewLog(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("日志")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_COPY",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_COPY'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(
                                            scope.row,
                                            4,
                                            ""
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("复制")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_EDIT",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_EDIT'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(scope.row, 2)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_DEL",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_DEL'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(scope.row, 3)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "影视资源", name: "films" } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          border: "",
                          data: _vm.tableData,
                          height: "600px",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "id", label: "ID", width: "180" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "title",
                            label: "内容标题",
                            width: "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "coverImg",
                            label: "内容图片",
                            width: "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                    },
                                    attrs: {
                                      src: scope.row.coverImg,
                                      "preview-src-list": [scope.row.coverImg],
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleClickItem.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "hdCoverImg",
                            label: "高清封面图片",
                            width: "180",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                    },
                                    attrs: {
                                      src: scope.row.hdCoverImg,
                                      "preview-src-list": [
                                        scope.row.hdCoverImg,
                                      ],
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleClickItem.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "displayOrder", label: "显示顺序" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "tags", label: "宣传标签" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "thirdPartyAppName",
                            label: "关联应用",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "status", label: "状态" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status === 0
                                    ? _c("span", [_vm._v("失效")])
                                    : scope.row.status === 1
                                    ? _c("span", [_vm._v("生效")])
                                    : scope.row.status === 2
                                    ? _c("span", [_vm._v("待生效")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "createTime", label: "创建日期" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "remark", label: "备注" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "effectStartTime", label: "上架时间" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status !== 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.effectStartTime) +
                                            " 至 " +
                                            _vm._s(scope.row.effectEndTime)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_LOG",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_LOG'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewLog(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("日志")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_COPY",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_COPY'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(
                                            scope.row,
                                            4,
                                            ""
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("复制")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_EDIT",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_EDIT'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(scope.row, 2)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "LIST_CONTENT_MANAGE_DEL",
                                          expression:
                                            "'LIST_CONTENT_MANAGE_DEL'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(scope.row, 3)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "乐播媒资", name: "lbMedia" } },
                  [
                    _c("media-table", {
                      attrs: { tableData: _vm.tableData },
                      on: {
                        clickImg: _vm.handleClickItem,
                        edit: (row) => {
                          _vm.handleClick(row, 2)
                        },
                        viewLog: (row) => {
                          _vm.viewLog(row)
                        },
                        del: (row) => {
                          _vm.handleClick(row, 3)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pagination.current,
                    "page-sizes": [10, 50, 100, 200],
                    "page-size": _vm.pagination.size,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.pagination.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "custom-dialog-min-width",
          attrs: {
            title: _vm.title,
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.visible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.addTabs,
                callback: function ($$v) {
                  _vm.addTabs = $$v
                },
                expression: "addTabs",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled: _vm.type === 2 && _vm.addTabs !== "live",
                    label: "直播赛事",
                    name: "live",
                  },
                },
                [
                  _c("LiveForm", {
                    ref: "liveForm",
                    on: {
                      close: _vm.onDialogClose,
                      reload: _vm.getListContent,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled: _vm.type === 2 && _vm.addTabs !== "films",
                    label: "影视内容",
                    name: "films",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticClass: "dialog-content-wrap",
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "editForm",
                          attrs: {
                            model: _vm.dialogForm,
                            rules: _vm.rules,
                            size: "small",
                            "label-width": "140px",
                          },
                        },
                        [
                          _vm._l(_vm.dialogForm.config, function (item) {
                            return _c(
                              "el-form-item",
                              {
                                key: item.id,
                                ref: item.name,
                                refInFor: true,
                                attrs: { label: item.label, prop: item.name },
                              },
                              [
                                item.type === "input"
                                  ? _c("el-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: { placeholder: item.placeholder },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    })
                                  : _vm._e(),
                                item.type === "select"
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: item.placeholder,
                                        },
                                        model: {
                                          value: item.value,
                                          callback: function ($$v) {
                                            _vm.$set(item, "value", $$v)
                                          },
                                          expression: "item.value",
                                        },
                                      },
                                      _vm._l(
                                        _vm.aplicationTypeList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.name,
                                              value: item.id,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                                item.id === 51
                                  ? _c("el-input", {
                                      staticStyle: {
                                        width: "200px",
                                        "margin-right": "10px",
                                      },
                                      attrs: { placeholder: item.placeholder },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    })
                                  : _vm._e(),
                                item.id === 51
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { size: "small" },
                                        on: { click: _vm.insertCategory },
                                      },
                                      [_vm._v("添加")]
                                    )
                                  : _vm._e(),
                                item.id === 51 && _vm.dialogForm.category
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      _vm._l(
                                        _vm.contentList,
                                        function (item, index) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: item,
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                              attrs: { closable: "" },
                                              on: {
                                                close: () => {
                                                  _vm.dialogForm.category =
                                                    _vm.contentList
                                                      .filter(
                                                        (tag, i) => i != index
                                                      )
                                                      .join(",")
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item))]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                                item.type === "textarea"
                                  ? _c("el-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        type: "textarea",
                                        rows: 2,
                                        placeholder: item.placeholder,
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    })
                                  : _vm._e(),
                                item.type === "radio"
                                  ? _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: item.value,
                                          callback: function ($$v) {
                                            _vm.$set(item, "value", $$v)
                                          },
                                          expression: "item.value",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("上架")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [_vm._v("下架")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.type === "upload"
                                  ? _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          action: "#",
                                          "list-type": "picture-card",
                                          "on-preview": (file) => {
                                            return _vm.handlePictureCardPreview(
                                              file,
                                              item
                                            )
                                          },
                                          "auto-upload": false,
                                          "file-list": _vm.uploadList(
                                            item.name
                                          ),
                                          "on-change": (file, file_list) => {
                                            return _vm.handleChangeImgs(
                                              file,
                                              file_list,
                                              item.name
                                            )
                                          },
                                          "on-remove": (file, file_list) => {
                                            return _vm.handleRemoveImgs(
                                              file,
                                              file_list,
                                              item
                                            )
                                          },
                                          limit: 1,
                                        },
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    )
                                  : _vm._e(),
                                item.type === "picSelectWidth"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value: _vm.imgSelectWidth,
                                              callback: function ($$v) {
                                                _vm.imgSelectWidth = $$v
                                              },
                                              expression: "imgSelectWidth",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "300" } },
                                              [_vm._v("小图：300px (推荐)")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "700" } },
                                              [_vm._v("大图：700px (推荐)")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: -1 } },
                                              [_vm._v("自定义图片宽度")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top-start",
                                              width: "200",
                                              trigger: "hover",
                                              content:
                                                "如果输入了自定义图片宽度，以自定义图片宽度为准",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                              staticStyle: {
                                                "margin-left": "40px",
                                                color: "#507dc5",
                                              },
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.type === "picInputWidth" &&
                                _vm.imgSelectWidth === -1
                                  ? _c("el-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: item.placeholder,
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function ($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value",
                                      },
                                    })
                                  : _vm._e(),
                                item.type === "upload"
                                  ? _c(
                                      "el-dialog",
                                      {
                                        attrs: {
                                          visible: _vm.dialogVisible,
                                          "append-to-body": "",
                                        },
                                        on: {
                                          "update:visible": function ($event) {
                                            _vm.dialogVisible = $event
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            width: "100%",
                                            src: item.value,
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                item.children
                                  ? _c("div", {
                                      staticStyle: { height: "32px" },
                                    })
                                  : _vm._e(),
                                _vm._l(item.children, function (subItem) {
                                  return _c(
                                    "div",
                                    {
                                      key: subItem.id,
                                      staticClass: "children",
                                    },
                                    [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v(_vm._s(subItem.label)),
                                      ]),
                                      _c("el-input", {
                                        staticStyle: { width: "400px" },
                                        attrs: {
                                          maxlength: "998",
                                          placeholder: subItem.placeholder,
                                        },
                                        model: {
                                          value: subItem.value,
                                          callback: function ($$v) {
                                            _vm.$set(subItem, "value", $$v)
                                          },
                                          expression: "subItem.value",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            )
                          }),
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态", prop: "status" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.dialogForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dialogForm, "status", $$v)
                                    },
                                    expression: "dialogForm.status",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("生效"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("失效"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.dialogForm.status === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "选择", prop: "effectMode" },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.dialogForm.effectMode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dialogForm,
                                            "effectMode",
                                            $$v
                                          )
                                        },
                                        expression: "dialogForm.effectMode",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("立即生效"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("指定时间生效"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.dialogForm.status === 1 &&
                          _vm.dialogForm.effectMode === 2
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "effectTime",
                                  attrs: {
                                    label: "生效时间",
                                    prop: "effectTime",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      size: "small",
                                      "picker-options": {
                                        disabledDate(time) {
                                          return (
                                            time.getTime() < Date.now() - 8.64e7
                                          )
                                        },
                                      },
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      type: "datetimerange",
                                      "range-separator": "至",
                                      "start-placeholder": "生效开始时间",
                                      "end-placeholder": "生效结束时间",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.dialogForm.effectTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dialogForm,
                                          "effectTime",
                                          $$v
                                        )
                                      },
                                      expression: "dialogForm.effectTime",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "btn" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.handleEdit },
                            },
                            [_vm._v("保存")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.onDialogClose },
                            },
                            [_vm._v("取消")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    disabled:
                      _vm.type === 1 ||
                      (_vm.type === 2 && _vm.addTabs !== "lbMedia"),
                    label: "乐播媒资",
                    name: "lbMedia",
                  },
                },
                [
                  _c("MediaForm", {
                    ref: "lbMediaForm",
                    on: {
                      close: _vm.onDialogClose,
                      reload: _vm.getListContent,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ImportDialog", {
        ref: "importDialog",
        on: { reload: _vm.getListContent },
      }),
      _c("import-lb-media", {
        ref: "importLbMedia",
        on: { reload: _vm.getListContent },
      }),
      _c("OptionLog", {
        ref: "optionLog",
        attrs: { columnConfig: _vm.optionLogColumn, closeBtn: false },
        on: { reload: _vm.reloadOpt },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function ({ row }) {
              return [
                _c("div", [
                  row.type === 1 ? _c("span", [_vm._v("新增")]) : _vm._e(),
                  row.type === 2 ? _c("span", [_vm._v("修改")]) : _vm._e(),
                  row.type === 3 ? _c("span", [_vm._v("删除")]) : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }